export default "__VITE_ASSET__iskgM0EQ__"